import { useTranslation } from 'react-i18next';
import { useUpdateEffect } from 'react-use';

import { SearchField, Skeleton, useSearching } from '@client/toolkit';

import { useAgreementListSearchQueryParams } from '../utils/use-agreement-list-query-params';

interface AgreementListToolbarProps {
  totalCount?: number;
  isFetching?: boolean;
}

export const AgreementListToolbar = ({ totalCount, isFetching }: AgreementListToolbarProps) => {
  const { t: tCommon } = useTranslation();
  const { t: tGlobal } = useTranslation('global');

  const [searchQueryParams, setSearchQueryParam] = useAgreementListSearchQueryParams();
  const { search, clearSearch, debouncedSearch, updateSearch } = useSearching({
    search: searchQueryParams.agreementsSearch,
  });

  useUpdateEffect(() => {
    setSearchQueryParam({
      agreementsSearch: debouncedSearch ?? undefined,
    });
  }, [debouncedSearch]);

  return (
    <div className="flex justify-between items-center px-4 py-4">
      <div className="flex w-6/12 items-center">
        <SearchField value={search} onChange={updateSearch} onClear={clearSearch} placeholder={tCommon('search')} />
{/* Commented out for search engine
        <div className="flex">
          {isFetching && <Skeleton variant="text" width="w-32" />}
          {!isFetching && (
            <span className="px-2 whitespace-nowrap text-white">{`${totalCount} ${tGlobal('entity.agreement', {
              count: totalCount,
              context: totalCount && totalCount > 1 ? 'plural' : 'singular',
            })}`}</span>
          )}
        </div>
*/}
      </div>
    </div>
  );
};
